module.exports = __webpack_public_path__ + "f1b0864ea31ea0393773f7ec360cd91e.svg";